const state = {
    tenant: null
}

// getters
const getters = {
    tenant: state => state.tenant
}

// actions
const actions = {
}

// mutations
const mutations = {
    setTenant (state, tenant) {
        console.log('STORE setting tenant: ' + tenant)
        state.tenant = tenant
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
